export class MotiveOccurrence {
  id!: number;
  contractId!: number;
  description!: string;
  type!: MotiveOccurrenceType;
  serviceTime!: number;
}

export enum MotiveOccurrenceType {
  technical = 'technical',
  nonTechnical = 'nonTechnical'
}

export class Occurrence{
  id!: number;
  userId!: number;
  contractId!: number;
  motiveId!: number;
  originId!: number;
  alertId!: number;

  deliveryProtocol!: string;
  description!: string;
  notes!: string;

  operation!: number;
  operationDescription!: string;
  equipment!: string;

  lane!: string;
  rejected!: boolean;
  motiveOccurrence!: MotiveOccurrence

  attachments!: Attachment[];

  protocolDate!: Date;
  protocolHour!: Date;

  startDate!: any;
  endDate!: any;
  startHour!: Date;
  endHour!: Date;
}

export class Attachment{
  id!: number;
  name!: string;
  type!: string;
  url!: string;
  previewUrl!: string;
  size!: number;
  userName!: string;
  uploadDate!: Date;
  occurrenceId!: number;
  userId!: number;
}
